import { Box, CircularProgress } from "@mui/material";
import * as React from "react";

import { InviteCard } from "./InviteCard";

export const InviteLoadingFallback: React.FC = () => {
  return (
    <InviteCard>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress size="1.75rem" />
      </Box>
    </InviteCard>
  );
};
